var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled, { css } from "styled-components";
import { H2 } from "@irati/ui/src/Typography";
import { FormattedMessage } from "@irati/utils/lang";
var ResponsiveH2 = styled(H2)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-left: ", ";\n    ", "\n  "], ["\n    margin-top: ", ";\n    margin-left: ", ";\n    ",
        "\n  "])), theme.spacing.two, theme.spacing.two, theme.mediaQueries.minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      margin-top: ", ";\n      margin-left: ", ";\n    "], ["\n      margin-top: ", ";\n      margin-left: ", ";\n    "])), theme.spacing.five, theme.spacing.five));
});
var TeCModalHeader = function () { return (React.createElement(ResponsiveH2, null,
    React.createElement(FormattedMessage, { id: "perks.components.importantInfoBlock.importantInfoBlock.tAndC" }))); };
export default TeCModalHeader;
var templateObject_1, templateObject_2, templateObject_3;
